module.exports = "/images/vendor/flag-icon-css/flags/1x1/vg.svg?a796b16d8f1c42862953487aed9bd660";